import AppDispatcher from '../dispatcher/AppDispatcher';
import NBAConstants from '../constants/NBAConstants';
import NBAParser from '../parsers/NbaParser';

class NBAActionCreator {
  // Action to get NBAs from API
  requestNBAData(accountType) {
    AppDispatcher.handleViewAction({
      actionType: NBAConstants.REQUEST_NBA_DATA,
      data: accountType,
    });
  }

  requestSplashData() {
    AppDispatcher.handleViewAction({
      actionType: NBAConstants.REQUEST_SPLASH_DATA,
    });
  }

  requestNBASettings() {
    AppDispatcher.handleViewAction({
      actionType: NBAConstants.REQUEST_NBA_SETTINGS,
    });
  }

  sendNBAContainerAcknowledgement(accountType, payload) {
    AppDispatcher.handleViewAction({
      actionType: NBAConstants.REQUEST_C_CONTAINER_ACK,
      payload,
      accountType,
    });
  }

  sendSplashAcknowledgement(accountType, payload) {
    AppDispatcher.handleViewAction({
      actionType: NBAConstants.REQUEST_SPLASH_ACK,
      payload,
      accountType,
    });
  }

  // TO HANDLE SERVER ACTIONS REQUEST_SPLASH_DATA_SUCCESS
  handleSplashDataSuccess(response, status) {
    const nbaData = NBAParser.getNBAContainer(response);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_SPLASH_DATA_SUCCESS,
      data: nbaData,
      status,
    });
  }

  handleSplashDataError(error, status) {
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_SPLASH_DATA_ERROR,
      data: error,
      status,
    });
  }

  handleNBADataSuccess(response, status) {
    const nbaData = NBAParser.getNBAContainer(response);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_DATA_SUCCESS,
      data: nbaData,
      status,
    });
  }

  handleNBADataError(error, status) {
    // console.log(error);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_DATA_ERROR,
      data: error,
      status,
    });
  }

  handleNBAProductDataSuccess(response, status) {
    // console.log(JSON.stringify(response));
    const nbaData = NBAParser.getNBAContainer(response);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_PRODUCT_DATA_SUCCESS,
      data: nbaData,
      status,
    });
  }

  handleNBAProductDataError(error, status) {
    // console.log(error);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_PRODUCT_DATA_ERROR,
      data: error,
      status,
    });
  }

  handleNBASetingsSuccess(response, status) {
    // console.log(JSON.stringify(response));
    const settings = NBAParser.getNBASettings(response);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_SETTINGS_SUCCESS,
      data: settings,
      status,
    });
  }

  handleNBASetingsError(error, status) {
    // console.log(error);
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_NBA_SETTINGS_ERROR,
      data: error,
      status,
    });
  }

  handleSplashSuccess(response, status) {
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_SPLASH_ACK_SUCCESS,
      data: response,
      status,
    });
  }

  handleSplashError(error, status) {
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_SPLASH_ACK_ERROR,
      data: error,
      status,
    });
  }

  handleNBAContainerSuccess(response, status) {
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_C_CONTAINER_ACK_SUCCESS,
      data: response,
      status,
    });
  }

  handleNBAContainerError(error, status) {
    AppDispatcher.handleServerAction({
      actionType: NBAConstants.REQUEST_C_CONTAINER_ACK_ERROR,
      data: error,
      status,
    });
  }
}

export default new NBAActionCreator();
